<template>
    <vx-card title="Просмотры виджета">
        <vs-table
            stripe
            v-if="hasSites"
            :data="sites"
        >
            <template slot="thead">
                <vs-th sort-key="domain">
                    <div class="flex justify-start w-full">
                        Домен
                    </div>
                </vs-th>
                <vs-th sort-key="visits">
                    <div class="flex justify-start w-full">
                        Просмотры
                    </div>
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td class="text-left whitespace-no-wrap" :data="data[indextr].domain">
                        {{ data[indextr].domain }}
                    </vs-td>

                    <vs-td  class="text-left whitespace-no-wrap" :data="data[indextr].visits">
                        {{ data[indextr].visits }}
                    </vs-td>
                </vs-tr>

                <tfoot class="w-full" v-if="isTotalShown">
                  <vs-tr>
                    <vs-td class="text-left whitespace-no-wrap font-bold">Всего</vs-td>
                    <vs-td class="text-left whitespace-no-wrap font-bold">{{ total }}</vs-td>
                  </vs-tr>
                </tfoot>
            </template>
        </vs-table>
        <div v-else>
            Нет данных
        </div>
    </vx-card>
</template>
<script>
export default {
  props: {
    visits: {
      type: Object,
      required: true
    }
  },
  computed: {
    total () {
      return this.visits.total
    },
    sites () {
      return this.visits.sites
    },
    hasSites () {
      return this.sites && this.sites.length > 0
    },
    isTotalShown () {
      return this.total > 0 && this.hasSites
    }
  }
}
</script>